<template lang="pug">
  .whb-month-wrapper
    h3 transações no mês ({{ employee.name }})

    SmartTable.table(
    name="whb-month-table-list"
    v-bind="table",
    v-model="tableData",
    ref="table"
    )
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")

          template(v-slot:isApproved="{ columnValue, rowItem, index }")
            .status.background-success(v-if="columnValue === true" key="index + 'aproved'")
              span.icon-ptt-icons-aprovar
            .status.background-danger(v-else,  key="index + 'reproved'")
              span.icon-ptt-icons-reprovar

          template(v-slot:expiration_date="{ columnValue, rowItem, index }")
            span {{ columnValue || '--' }}

          template(v-slot:type="{ columnValue }")
            span.no-wrap(:title="columnValue") {{ columnValue }}

          template(v-slot:generalExtraTime="{ columnValue, rowItem, index }")
            span.counts.background-success {{ columnValue }}

          template(v-slot:generalDelay="{ columnValue, rowItem, index }")
            span.counts.background-danger {{ columnValue }}

          template(v-slot:allTimes="{ columnValue, rowItem, index }")
            span.counts(:class="{[`background-${ columnValue[0] === '-' ? 'danger' : 'success' }`]: true}")
              | {{ columnValue }}

      template(v-slot:detailsBox="{item}")
        DBLabel(title="tipo", :body="item.type")

        h3(style="text-align: left") acumuladas:
        .flex
          DBLabel(title="horas extras:", :body="item.extraTime50Tot || '00:00'")
          DBLabel(title="horas extras extraordinárias:", :body="item.extraTime100Tot || '00:00'")
          DBLabel(title="horas extras especiais:", :body="item.extraTimeSpecialTot || '00:00'")
          DBLabel(title="horas extras noturnas:", :body="item.extraTime50NotTot || '00:00'")
          DBLabel(title="horas extras extraord. noturnas:", :body="item.extraTime100NotTot || '00:00'")
          DBLabel(title="horas extras especiais noturnas:", :body="item.extraTimeSpecialNotTot || '00:00'")
          DBLabel(title="horas de atraso:", :body="item.delayTime || '00:00'")
          DBLabel(title="saída antecipada:", :body="item.earlyExit || '00:00'")
          DBLabel(title="excesso de pausa:", :body="item.lunchPenalty || '00:00'")
          DBLabel(title="horas de falta:", :body="item.absenceHours || '00:00'")

          PButton(color="danger" size="md" v-if="!item.isCompensated && item.isArbitrary" @click="deleteWhbo(item)"
          has-permission="{module: 'workhourbankobjects', action: 'delete', hide: true}")
            | apagar

          template(v-if="showApproveReprove")
            PButton(color="danger" size="md" v-if="item.isApproved && !item.isCompensated" @click="reproveWhbo(item)"
            has-permission="{module: 'workhourbankauth', action: 'post', hide: true}")
              | reprovar

            PButton(color="success" size="md" v-if="!item.isApproved && !item.isCompensated" @click="approveWhbo(item)"
            has-permission="{module: 'workhourbankauth', action: 'post', hide: true}")
              | aprovar

</template>

<script>
import DBLabel from 'src/common/SmartTable/DBLabel'
import moment from 'moment'

function sortDatesAlreadyFormated ({field, order, itemA, itemB}) {
  const dateA = moment(itemA[field], 'DD.MM.YY')
  const dateB = moment(itemB[field], 'DD.MM.YY')

  return order === 'asc' ? dateB.diff(dateA) : dateA.diff(dateB)
}

export default {
  name: 'WhbMonth',
  components: {DBLabel},
  props: {
    employee: {type: Object, required: true}
  },
  created () {
    this.fetchMonthData()
  },
  data () {
    return {
      table: {
        headerItems: [
          {
            column: 'status',
            field: 'isApproved',
            width: '0.8fr',
            options: [
              {text: 'todos'},
              {iconClass: 'icon-ptt-icons-predio-aprovar', text: 'aprovado'},
              {iconClass: 'icon-ptt-icons-predio-reprovar', text: 'reprovado'}
            ],
            filterFunction: ({search, item}) => {
              if (search === 'todos') return true

              return search === 'aprovado' ? item.isApproved === true : item.isApproved === false
            }
          },
          {column: 'data', field: 'date', width: '0.6fr', sortFunction: sortDatesAlreadyFormated},
          {column: 'validade', field: 'expiration_date', width: '0.65fr', sortFunction: sortDatesAlreadyFormated},
          {column: 'tipo', field: 'type', width: '1.3fr'},
          {column: 'acumuladas', field: 'generalExtraTime', width: '0.8fr'},
          {column: 'compensadas', field: 'generalDelay', width: '0.85fr'},
          {column: 'total', field: 'allTimes', width: '0.75fr'}
        ],
        config: {
          detailsBox: {
            columnsKeep: ['status', 'date', 'expiry']
          },
          defaultSortField: 'date',
          defaultColumnSearch: 'date'
        }
      },
      tableData: {
        loaded: [],
        loading: false,
        totalItems: null
      }
    }
  },
  computed: {
    showApproveReprove () {
      return !this.$store.getters['frontOptions'].whbCannotApprove
    }
  },
  methods: {
    async fetchMonthData () {
      this.tableData.loaded = []

      if (this.$refs.table) {
        this.$refs.table.closeDetailsBox()
      }
      this.tableData.loading = true

      const result = await this.$API.whboManager.get({employeeId: this.employee.id})

      this.tableData.loading = false
      this.tableData.loaded = result.data.success
    },
    async deleteWhbo ({ id }) {
      try {
        await this.$API.whboCreate.delete({kind: 'delete', id})
        this.fetchMonthData()
      } catch (e) {
        this.$swal({kind: 'error', title: 'Aconteceu um erro', text: 'Não foi possível apagar o banco de horas'})
      }
    },
    async approveWhbo ({ id }) {
      try {
        await this.$API.whboAuth.save({approve: 'approve', whobId: id}, {})
        this.fetchMonthData()
      } catch (e) {
        this.$swal({kind: 'error', title: 'Aconteceu um erro', text: 'Não foi possível aprovar o banco de horas'})
      }
    },
    async reproveWhbo ({ id }) {
      try {
        await this.$API.whboAuth.save({approve: 'disapprove', whobId: id}, {})
        this.fetchMonthData()
      } catch (e) {
        this.$swal({kind: 'error', title: 'Aconteceu um erro', text: 'Não foi possível reprovar o banco de horas'})
      }
    }
  }
}
</script>

<style scoped lang="scss">
.whb-month-wrapper {
  h3 {
    text-align: center;
  }

  .table {
    span.counts {
      text-align: center;
      width: 50%;
    }

    .status {
      width: 30px !important;
      display: grid;
      align-items: center;
      justify-items: center;
      height: 70%;
    }
  }
  .flex {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 20px;
  }
}
</style>
